export const BPDATA_GET_PATIENTS_REQUESTED = 'BPDATA_GET_PATIENTS_REQUESTED';
export const BPDATA_GET_PATIENTS_SUCCESS = 'BPDATA_GET_PATIENTS_SUCCESS';
export const BPDATA_GET_PATIENTS_FAILED = 'BPDATA_GET_PATIENTS_FAILED';

export const BPDATA_GET_DETAILS_REQUESTED = 'BPDATA_GET_DETAILS_REQUESTED';
export const BPDATA_GET_DETAILS_SUCCESS = 'BPDATA_GET_DETAILS_SUCCESS';
export const BPDATA_GET_DETAILS_FAILED = 'BPDATA_GET_DETAILS_FAILED';

export const BPDATA_UPDATE_SUBSCRIPTION_REQUESTED = 'BPDATA_UPDATE_SUBSCRIPTION_REQUESTED';
export const BPDATA_UPDATE_SUBSCRIPTION_SUCCESS = 'BPDATA_UPDATE_SUBSCRIPTION_SUCCESS';
export const BPDATA_UPDATE_SUBSCRIPTION_FAILED = 'BPDATA_UPDATE_SUBSCRIPTION_FAILED';

export const BPDATA_ACTIVE_PATIENT = 'BPDATA_ACTIVE_PATIENT';

export const BPDATA_REMOVE_PATIENT = 'BPDATA_REMOVE_PATIENT';
